import styled from "styled-components";

export const ConditionSizr = styled.div`
    width: 97px;
`;